export default {"src":"/_next/static/media/low-quality.50960df6.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};